import styled from 'styled-components';

export const Icon = styled.img<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  vertical-align: middle;
  border-radius: 50%;
`;
